import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { format } from "date-fns";

import { getStatistic } from "@/services/API/statistic";
import { RootState } from "@/store/store";
import { setLoading } from "@/store/ui/ui";
import { setDebtorsArray } from "@/store/statistic/statistic";

import { IHandleGetStats } from "@/shared/interfaces/patientPage";

export default function useGetStatistic() {
    const dispatch = useDispatch();
    const globalDate = useSelector(
        (state: RootState) => state.schedule.globalDate,
    );
    const onlyDate = format(globalDate, "yyyy-MM-dd");

    async function handleGetStats({
        entity,
        message,
        onSuccess,
    }: IHandleGetStats) {
        dispatch(setLoading(true));
        const response = await getStatistic(entity, onlyDate);
        if (response?.status === "success" && response.data) {
            onSuccess?.();
            dispatch(setDebtorsArray([...response.data]));
            toast.success(message);
        } else {
            toast.error(response?.error || "Помилка при отриманні даних");
        }
        dispatch(setLoading(false));
    }

    return { handleGetStats };
}
